/*
  Icon Walls — minimales Vanilla-JS
  - Reveal-on-Scroll (IntersectionObserver), respektiert prefers-reduced-motion
  - Sticky Add-to-Cart Sichtbarkeit auf PDP (mobil)
  Keine externen Abhängigkeiten.
*/
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.iw-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('iw-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('iw-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Sticky ATC (PDP mobil): einblenden sobald Haupt-CTA aus dem Viewport ist ---- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-iw-sticky-atc]');
    if (!bar) return;
    var anchor = document.querySelector('[data-iw-atc-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  function init() {
    initReveal();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
